import UmlShape from './UmlShape';

// PlantUML note-element: dashed box, geen children.
class UmlCommentShape extends UmlShape {
  constructor(id, x, y, w, h, text) {
    super(id, x, y, w, h);
    this.text = text;
    this.linkedShapeId = null; // optionele koppeling aan een Package/Class, zie design V1
    this.kind = 'comment'; // discriminant voor UmlShapeSerializer.fromPlainShape (JSON heeft geen class-info)
  }

  setText(text) {
    this.text = text;
  }

  linkTo(shapeId) {
    this.linkedShapeId = shapeId;
  }
}

export default UmlCommentShape;
